module.exports = __webpack_public_path__ + "static/media/Roseto - Orange_DK Grey.7c8df7b8.jpg";